import type { ColDef, ValueFormatterParams } from 'ag-grid-community'
import { ModuleRegistry } from 'ag-grid-community'
import { AllEnterpriseModule } from 'ag-grid-enterprise'
import { useMemo } from 'react'

import { Signal } from '@/gen/inventory/v1/signal_pb'

import { formatTimestamp } from '@/lib/date/date'

import { AgDataTable } from '@/components/lemmala-design-system/table'
import { TABLE_COLUMN_WIDTHS } from '@/components/lemmala-design-system/table/consts'

ModuleRegistry.registerModules([AllEnterpriseModule])

type InstanceAlertTableProps = {
  signals: Signal[]
}

export const InstanceAlertTable = ({ signals }: InstanceAlertTableProps) => {
  const columnDefs = useMemo<ColDef<Signal>[]>(
    () => [
      {
        colId: 'subtitle',
        field: 'subtitle',
        headerName: 'Instance',
        flex: 1,
        minWidth: TABLE_COLUMN_WIDTHS.lg,
      },
      {
        colId: 'createdAt',
        field: 'createdAt',
        headerName: 'Created At',
        width: TABLE_COLUMN_WIDTHS.md,
        valueFormatter: (params: ValueFormatterParams<Signal>) =>
          formatTimestamp(params.value, 'dateTime') ?? '',
      },
    ],
    [],
  )

  return <AgDataTable<Signal> rowData={signals} columnDefs={columnDefs} />
}
